const it = {
  services: {
    seoTitle: "Servizi · Hotel Ciutat Martorell a Martorell",
    seoDesc: "Tutti i servizi dell'hotel e delle camere: Business Corner, ristorante My Bar, parcheggio, palestra, WiFi gratuito, reception 24h e molto altro.",
    eyebrow: "Servizi",
    title: "Tutto ciò di cui hai bisogno per un soggiorno confortevole",
    hotelTitle: "Servizi dell'hotel",
    hotel: [
      "Aria condizionata e riscaldamento",
      "Ascensori",
      "Buffet colazione giornaliero",
      "Business Corner",
      "Deposito bagagli",
      "Palestra",
      "Materiale audiovisivo",
      "Parcheggio",
      "Reception 24h",
      "Ristorante My Bar, aperto tutti i giorni per pranzo e cena",
      "Servizio in camera 24h",
      "Sale riunioni e banchetti",
      "Servizio di lavanderia / lavaggio a secco",
      "Servizio di stampa",
      "WiFi gratuito",
    ],
    roomsTitle: "In camera",
    rooms: [
      "Adatte a persone con mobilità ridotta",
      "Aria condizionata e riscaldamento individuali",
      "Prodotti da bagno",
      "Bagno completo con doccia o vasca e/o bidet",
      "Scrivania",
      "Minibar",
      "Asciugacapelli",
      "Televisore a schermo piatto con ingresso USB",
      "Telefono in camera e in bagno",
      "WiFi gratuito",
      "Culla disponibile",
      "Letto aggiuntivo",
      "Camere per non fumatori",
    ],
    fitness: {
      eyebrow: "Palestra",
      title: "Sala fitness",
      text: "Mantieni la tua routine durante il soggiorno nella nostra sala fitness, dotata di tapis roulant, cyclette e manubri.",
      alts: ["Sala fitness con cyclette, tapis roulant e asciugamani", "Sala fitness con tapis roulant, cyclette e manubri davanti allo specchio"],
    },
    shop: {
      eyebrow: "Prodotti ufficiali",
      title: "La passione del calcio, in reception",
      text: "Nella nostra reception troverai prodotti ufficiali del FC Barcelona e del Real Madrid. Porta con te la passione della tua squadra.",
      note: "In vendita solo in reception",
      cta: "Chiedi in reception",
      clubs: [
        { name: "FC Barcelona", items: "Maglie, cappellini, sciarpe, zaini, palloni e molto altro." },
        { name: "Real Madrid", items: "Maglie, completi, cappellini, palloni, sciarpe e molto altro." },
      ],
    },
  },
  nav: {
    nye: "Capodanno 2026",
    hotel: "L'Hotel",
    rooms: "Camere",
    services: "Servizi",
    corporate: "Aziende & Sale",
    events: "Eventi & Matrimoni",
    restaurant: "Ristorante",
    location: "Posizione",
    biosphere: "Sostenibilità",
    gallery: "Galleria",
    blog: "Blog",
    contact: "Contatto",
    book: "Prenota diretto",
    menu: "Menu",
    close: "Chiudi",
    call: "Chiama",
    map: "Mappa",
    bookShort: "Prenota",
  },
  hero: {
    availability: "Verifica disponibilità",
    checkin: "Check-in",
    checkout: "Check-out",
    adults: "Adulti",
    children: "Bambini",
    promo: "Codice promo",
    promoPlaceholder: "Facoltativo",
    bestPrice: "Miglior prezzo garantito prenotando qui",
    scroll: "Scorri",
  },
  attrs: [
    { t: "Miglior prezzo garantito", d: "Prenotando diretto" },
    { t: "Cancellazione flessibile", d: "Secondo la tariffa" },
    { t: "Colazione a buffet", d: "Dalle 06:30 alle 10:30" },
    { t: "Parcheggio privato", d: "Con supplemento, secondo disponibilità" },
    { t: "100 m da Renfe & FGC", d: "30 min da Barcellona" },
  ],
  marquee: ["Martorell", "30 min Barcellona", "Montserrat", "Renfe & FGC a 100 m", "Zona aziendale SEAT-CUPRA", "Comfort 4 stelle", "92 camere", "Prenotazione diretta"],
  home: {
    presEyebrow: "L'hotel",
    stats: [
      { n: "92", l: "camere standard" },
      { n: "100 m", l: "da Renfe e FGC" },
      { n: "30 min", l: "da Barcellona e dall'aeroporto" },
      { n: "180", l: "persone nella sala principale" },
    ],
    roomsEyebrow: "Camere",
    roomsTitle: "Riposo su misura",
    roomsText: "Due tipologie pensate per il viaggiatore d'affari, le famiglie e i soggiorni lunghi.",
    roomsCta: "Vedi tutte le camere",
    from: "Da",
    detail: "Vedi dettaglio",
    corpEyebrow: "Aziende & riunioni",
    corpTitle: "Un hub aziendale|a 5 minuti da SEAT-CUPRA",
    corpFeatures: ["3 sale riunioni", "Fino a 180 persone", "Connessione WiFi e materiale audiovisivo", "Coffee break e pranzi di lavoro"],
    corpCta: "Richiedi un preventivo",
    corpSecondary: "Vedi le sale",
    restEyebrow: "Gastronomia",
    restCta: "Scopri il ristorante",
    locEyebrow: "Posizione",
    locCta: "Come arrivare",
    galleryEyebrow: "Galleria",
    galleryCta: "Vedi la galleria completa",
    directEyebrow: "Prenotazione diretta",
    directTitle: "Prenotare qui conviene sempre",
    directItems: [
      { t: "Miglior prezzo online", d: "Nessuna agenzia ti offrirà una tariffa più bassa del nostro sito." },
      { t: "Condizioni flessibili", d: "Tariffe con cancellazione gratuita e pagamento in hotel." },
      { t: "Contatto diretto", d: "Parli con il team dell'hotel, senza intermediari, prima e dopo il soggiorno." },
      { t: "Attenzioni di benvenuto", d: "Check-out posticipato secondo disponibilità e vantaggi esclusivi per clienti diretti." },
    ],
    testimonialsEyebrow: "Recensioni",
    testimonials: [
      { q: "Posizione perfetta per lavorare nella zona industriale. Camere silenziose e colazione completa. Torniamo ogni mese.", a: "Marc V.", r: "Viaggio di lavoro" },
      { q: "Abbiamo festeggiato la comunione di nostra figlia nella sala e tutto è stato impeccabile. Il team si è occupato di ogni dettaglio.", a: "Laura & Jordi", r: "Festa di famiglia" },
      { q: "Treno a 2 minuti a piedi e Barcellona in mezz'ora. Una base tranquilla e ben curata per visitare la città e Montserrat.", a: "Claire D.", r: "Fuga" },
    ],
    contactEyebrow: "Parliamone",
    contactCta: "Contattaci",
    rfpCta: "Richiedi un preventivo",
  },
  rooms: {
    eyebrow: "Camere",
    surface: "Superficie",
    occupancy: "Occupazione",
    bed: "Letto",
    bath: "Bagno",
    features: "Dotazioni",
    guests: "persone",
    book: "Prenota questa camera",
    all: "Tutte le camere",
    photosEyebrow: "Galleria",
    photosTitle: "Camera e bagno",
    photosCount: "foto",
    featureLabels: {
      wifi: "Wi-Fi ad alta velocità",
      ac: "Climatizzazione",
      tv: "TV",
      desk: "Scrivania da lavoro",
      minibar: "Minibar",
      hairdryer: "Asciugacapelli",
      crib: "Culla disponibile",
      extra_bed: "Letto aggiuntivo",
      accessible: "Accessibile",
      nonsmoking: "Non fumatori",
    },
    servicesEyebrow: "Servizi",
    family: {
      eyebrow: "Viaggi in famiglia",
      title: "Opzioni per famiglie",
      beds: { t: "Letto aggiunto (tripla)", d: "Trasforma la tua camera in tripla con un letto aggiunto. Gratuito per i minori di 12 anni." },
      crib: { t: "Culla gratuita", d: "Culle disponibili senza costi per i più piccoli." },
      note: "Entrambe le opzioni sono soggette a disponibilità; richiedile in anticipo al momento della prenotazione.",
    },
    servicesTitle: "Abbiamo tutto ciò di cui hai bisogno",
    services: [
      { t: "Colazione a buffet", d: "Prodotti locali, pasticceria artigianale e opzioni salutari ogni mattina." },
      { t: "Parcheggio privato", d: "Con supplemento, secondo disponibilità." },
      { t: "Wi-Fi in fibra", d: "Connessione simmetrica in tutto l'hotel, senza costi aggiuntivi." },
      { t: "Reception 24 h", d: "Team disponibile a qualsiasi ora per ciò di cui hai bisogno." },
      { t: "Sala fitness", d: "Mantieni la tua routine durante il soggiorno." },
      { t: "Ristorante & bar", d: "Menu di lavoro, carta mediterranea e drink tranquilli." },
    ],
    notFound: "Camera non trovata",
  },
  corporate: {
    eyebrow: "Aziende",
    title: "La vostra base operativa nel corridoio industriale del Llobregat",
    pillars: [
      { t: "Tariffe aziendali", d: "Prezzi negoziati per aziende con soggiorni frequenti e fatturazione centralizzata." },
      { t: "Sale riunioni", d: "Tre spazi modulari, da 12 a 180 persone." },
      { t: "Lavorare e riposare", d: "Scrivania in ogni camera, Wi-Fi e colazione dalle prime ore." },
      { t: "Catering di lavoro", d: "Coffee break, pranzi di lavoro e cene di team nello stesso hotel." },
    ],
    salasEyebrow: "Sale riunioni",
    photosTitle: "Sala ed eventi",
    salasTitle: "Spazi che si adattano alla vostra agenda",
    salasCta: "Vedi tutte le sale e le capacità",
    formEyebrow: "Tariffa azienda",
    formTitle: "Richiedete la vostra tariffa aziendale",
    formText: "Diteci quante notti all'anno serve al vostro team e vi prepareremo una proposta in meno di 24 ore.",
    capacityTitle: "Capacità per allestimento",
    capacityLabels: { teatro: "Platea", escuela: "Banchi di scuola", u: "A ferro di cavallo", imperial: "Imperiale", coctel: "Cocktail", banquete: "Banchetto" },
    equipmentLabels: {
      wifi: "Wi-Fi in fibra", proyector: "Proiettore & schermo", flipchart: "Lavagna a fogli", pizarra: "Lavagna",
      coffee_break: "Coffee break", agua: "Acqua minerale", escritura: "Materiale per scrivere", luz_natural: "Luce naturale", panelable: "Divisibile",
    },
    area: "Superficie",
    people: "pers.",
    upTo: "Fino a",
    requestRoom: "Richiedi un preventivo per questa sala",
    salasIntro: "Tutte le sale dispongono di Wi-Fi in fibra, climatizzazione indipendente, attrezzatura audiovisiva e servizio coffee break. Vi aiutiamo a scegliere l'allestimento ideale.",
    servicesTitle: "Servizi per il vostro evento",
    services: ["Coffee break di benvenuto e di metà mattina", "Pranzo di lavoro o buffet di lavoro", "Alloggio per relatori e partecipanti", "Parcheggio per i partecipanti", "Supporto tecnico durante l'evento", "Segreteria e materiale per scrivere"],
    otherRooms: "Altre sale",
    notFound: "Sala non trovata",
  },
  events: {
    eyebrow: "Eventi & celebrazioni",
    title: "I grandi giorni meritano un luogo all'altezza",
    intro: "Matrimoni, comunioni, anniversari e incontri di gruppo in una sala di 220 m² con luce naturale, cucina propria e 92 camere perché nessuno debba guidare per tornare.",
    types: [
      { key: "weddings", t: "Matrimoni", d: "Banchetti fino a 150 invitati, cocktail di benvenuto e suite nuziale in omaggio.", cta: "Scopri i matrimoni" },
      { key: "celebrations", t: "Celebrazioni", d: "Comunioni, battesimi, compleanni e anniversari con menu su misura per tutte le età.", cta: "Vedi le celebrazioni" },
      { key: "groups", t: "Gruppi", d: "Squadre sportive, viaggi organizzati e pellegrini a Montserrat con condizioni speciali.", cta: "Gruppi & viaggi" },
    ],
    stepsEyebrow: "Come lo facciamo",
    steps: [
      { t: "Ci conosciamo", d: "Visita all'hotel, ascoltiamo la vostra idea e proponiamo spazi e menu." },
      { t: "Proposta su misura", d: "Preventivo chiuso in 48 h, senza sorprese, con degustazione preliminare per i matrimoni." },
      { t: "Il grande giorno", d: "Un coordinatore dedicato gestisce tempi e fornitori perché voi dobbiate solo godervi tutto." },
    ],
    formEyebrow: "Raccontateci il vostro evento",
    formTitle: "Iniziamo a pianificarlo",
    weddings: {
      title: "Matrimoni a Martorell, a mezz'ora da Barcellona",
      intro: "Una sala divisibile con luce naturale per il banchetto, una terrazza per il cocktail e camere per gli sposi e i loro invitati. Cucina mediterranea propria e un coordinatore dedicato dal primo caffè all'ultimo ballo.",
      includes: ["Cocktail di benvenuto", "Banchetto con menu degustazione preliminare", "Suite nuziale in omaggio", "Tariffe speciali per gli invitati", "Open bar e DJ opzionali"],
    },
    celebrations: {
      title: "Comunioni, battesimi e anniversari",
      intro: "Celebrazioni familiari con menu pensati per grandi e piccoli, spazio per l'animazione dei bambini e la tranquillità di avere tutto sotto lo stesso tetto.",
      includes: ["Menu per bambini e adulti", "Spazio per l'animazione", "Decorazione su misura", "Torta personalizzata", "Zona fotografie", "Camere per i familiari"],
    },
    groups: {
      title: "Gruppi, squadre e viaggi organizzati",
      intro: "Alloggio per gruppi da 10 a 180 persone con colazione anticipata, cene di gruppo e check-in rapido. Il punto di partenza ideale per Montserrat e Barcellona.",
      includes: ["Tariffe di gruppo da 10 camere", "Colazione anticipata su richiesta", "Cene e picnic di gruppo", "Check-in collettivo"],
    },
    includesTitle: "Incluso nella proposta",
    back: "Tutti gli eventi",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Cucina mediterranea di mercato",
    hoursTitle: "Orari",
    breakfast: "Colazione",
    lunch: "Pranzo",
    dinner: "Cena",
    menuEyebrow: "Proposte",
    menus: [
      { t: "Colazione a buffet", d: "Pasticceria artigianale, frutta fresca, salumi catalani, uova al momento e caffè specialty.", p: "06:30 – 10:30" },
      { t: "Menu di lavoro", d: "Dal lunedì al venerdì a pranzo. Tre portate di mercato con pane, bevanda e caffè.", p: "Prezzo su richiesta" },
      { t: "Carta mediterranea", d: "Risotti, pesce del giorno, carni alla brace e dolci della casa con vini del Penedès.", p: "Cene e fine settimana" },
      { t: "Menu di gruppo", d: "Proposte fisse per aziende, celebrazioni e gruppi di viaggio a partire da 10 commensali.", p: "Su misura" },
    ],
    reserveTitle: "Prenota un tavolo",
    reserveText: "Chiamaci e confermiamo subito il tuo tavolo.",
    reserveCta: "Chiama il ristorante",
    reserveTap: "Tocca per chiamare",
    wineEyebrow: "Cantina",
    wineTitle: "Vini del Penedès e di tutta la Catalogna",
    wineText: "Una carta breve e onesta che privilegia le piccole cantine della regione: cava, xarel·lo e grenache che accompagnano la cucina di stagione.",
  },
  location: {
    eyebrow: "Posizione & collegamenti",
    title: "Al centro di tutto ciò che conta",
    pois: [
      { name: "Stazione Renfe / FGC Martorell Enllaç", dist: "100 m", time: "2 min a piedi", mode: "walk" },
      { name: "Sede SEAT-CUPRA e poli industriali", dist: "2,5 km", time: "5 min in auto", mode: "car" },
      { name: "Monastero e Parco Naturale di Montserrat", dist: "19 km", time: "20 min in auto / cremagliera", mode: "car" },
      { name: "Centro di Barcellona (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 min in treno diretto o A-2", mode: "train" },
      { name: "Aeroporto Barcellona-El Prat (BCN)", dist: "32 km", time: "25 min in autostrada", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 min via AP-7", mode: "car" },
    ],
    faqEyebrow: "Domande frequenti",
    faqTitle: "Come arrivare e muoversi",
    mapCta: "Apri in Google Maps",
    appleCta: "Apri in Apple Mappe",
    addressTitle: "Indirizzo",
    transportTitle: "Trasporti",
    transportItems: [
      { t: "In treno", d: "Renfe R4 e FGC (Martorell Enllaç / Martorell Central) a 100 m. Barcellona in 30 min." },
      { t: "In auto", d: "Uscite dirette dall'A-2 (uscita 585 Martorell) e dall'AP-7 (uscita 25 Martorell)." },
      { t: "Dall'aeroporto", d: "25 minuti in autostrada. Taxi o noleggio auto consigliati." },
    ],
  },
  gallery: {
    eyebrow: "Galleria",
    title: "L'hotel, in immagini",
    all: "Tutto",
    cats: { habitaciones: "Camere", restaurante: "Ristorante", salas: "Sale riunioni", eventos: "Eventi", fitness: "Sala fitness", comunes: "Aree comuni" },
  },
  blog: {
    eyebrow: "Blog & guide",
    title: "Martorell, Barcellona e Montserrat con calma",
    read: "min di lettura",
    readMore: "Leggi l'articolo",
    back: "Torna al blog",
    related: "Articoli correlati",
    notFound: "Articolo non trovato",
  },
  contact: {
    eyebrow: "Contatto",
    title: "Parliamo del vostro soggiorno o del vostro evento",
    text: "Rispondiamo in meno di 24 ore lavorative. Per le prenotazioni delle camere, utilizzate il nostro motore di prenotazione diretta con il miglior prezzo garantito.",
    phone: "Telefono",
    email: "Email",
    address: "Indirizzo",
    hours: "Reception 24 ore",
    formEyebrow: "Modulo",
    formTitle: "Come possiamo aiutarvi?",
  },
  form: {
    type: "Tipo di richiesta",
    types: { contacto: "Richiesta generale", empresa: "Tariffa aziendale", salas: "Preventivo sale / riunioni", evento: "Matrimonio / celebrazione / gruppo", restaurante: "Prenotazione ristorante" },
    name: "Nome e cognome",
    company: "Azienda / organizzazione",
    email: "Email",
    phone: "Telefono",
    nights: "Notti all'anno (circa)",
    guests: "Persone / commensali",
    date: "Data prevista",
    attendees: "Numero di partecipanti",
    eventType: "Tipo di evento",
    eventTypes: ["Matrimonio", "Comunione / battesimo", "Anniversario", "Riunione / formazione", "Convegno", "Gruppo di viaggio", "Altro"],
    setup: "Allestimento preferito",
    setups: ["Platea", "Banchi di scuola", "Ferro di cavallo", "Imperiale", "Cocktail", "Banchetto"],
    catering: "Catering",
    caterings: ["Coffee break", "Pranzo di lavoro", "Cena", "Senza catering"],
    lodging: "Avete bisogno di alloggio?",
    lodgings: ["Sì", "No", "Da confermare"],
    message: "Commenti",
    messagePlaceholder: "Diteci di cosa avete bisogno…",
    consent: "Ho letto e accetto l'informativa sulla privacy e il trattamento dei miei dati per gestire questa richiesta.",
    submit: "Invia richiesta",
    sending: "Invio…",
    success: "Richiesta inviata. Vi risponderemo entro 24 h.",
    error: "Impossibile inviare. Riprovate o chiamateci.",
    required: "Campo obbligatorio",
    invalidEmail: "Email non valida",
    consentRequired: "Dovete accettare l'informativa sulla privacy",
    select: "Seleziona",
  },
  footer: {
    tagline: "Hotel 4 stelle a Martorell. Riposo, lavoro e celebrazioni a 30 minuti da Barcellona.",
    explore: "Esplora",
    business: "Aziende",
    guides: "Guide",
    legal: "Legale",
    contact: "Contatto",
    legalNotice: "Note legali",
    privacy: "Privacy",
    cookies: "Cookie",
    cookieSettings: "Impostazioni cookie",
    rights: "Tutti i diritti riservati.",
    registration: "Registro turistico",
    newsletter: "Ricevi offerte dirette",
    newsletterText: "Scriviamo solo quando c'è qualcosa che vale la pena.",
    subscribe: "Iscriviti",
    subscribed: "Grazie, vi terremo informati.",
    directBook: "Prenotazione diretta · Miglior prezzo garantito",
  },
  legal: {
    legal: { title: "Note legali", date: "ottobre 2026", sections: [
      ["Dati identificativi", "In ottemperanza a quanto previsto dalla Legge 34/2002, dell'11 luglio, sui servizi della società dell'informazione e del commercio elettronico (LSSI-CE), si comunicano i seguenti dati:\nTitolare: EYE STAR, S.L.\nNome commerciale: Hotel Ciutat Martorell\nNIF: B87171740\nSede legale: Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), Spagna\nIndirizzo dell'esercizio: Avda. Pau Claris, s/n, 08760 Martorell (Barcellona), Spagna\nTelefono: +34 937 745 160\nIndirizzo e-mail: info@hotel-martorell.com\nSito web: www.hotel-martorell.com\nDati registrali: Registro delle Imprese di Madrid, Volume 32963, Foglio 138, Scheda M-593334, Iscrizione 1ª."],
      ["Oggetto", "Le presenti Note legali disciplinano l'accesso, la navigazione e l'utilizzo del sito web www.hotel-martorell.com, nonché le responsabilità derivanti dall'utilizzo dei suoi contenuti e, se del caso, dei servizi che possono essere offerti tramite lo stesso.\nL'accesso e la navigazione nel sito web attribuiscono la qualifica di utente e implicano l'accettazione delle condizioni riportate nelle presenti Note legali."],
      ["Condizioni d'uso", "L'utente si impegna a utilizzare il sito web in conformità alla legislazione vigente, alla buona fede, all'ordine pubblico e alle presenti Note legali.\nL'utente dovrà astenersi dall'utilizzare il sito web per finalità illecite o contrarie a quanto stabilito nelle presenti Note legali, nonché dal porre in essere qualsiasi azione che possa danneggiare, rendere inutilizzabile, sovraccaricare o deteriorare il sito web, i suoi contenuti o i sistemi e le apparecchiature che lo supportano."],
      ["Proprietà intellettuale e industriale", "Tutti i contenuti del sito web, inclusi, a titolo esemplificativo e non limitativo, testi, fotografie, immagini, grafica, loghi, icone, design, struttura, codice sorgente e altri elementi che fanno parte del sito web, sono di titolarità di EYE STAR, S.L. o sono utilizzati con la corrispondente autorizzazione dei legittimi titolari.\nTali contenuti sono protetti dalla normativa vigente in materia di proprietà intellettuale e industriale.\nÈ vietata la riproduzione, distribuzione, comunicazione pubblica, trasformazione o qualsiasi altra forma di sfruttamento, totale o parziale, dei contenuti del sito web senza la previa ed espressa autorizzazione di EYE STAR, S.L., salvo nei casi legalmente consentiti."],
      ["Responsabilità", "EYE STAR, S.L. si adopererà affinché i contenuti del sito web siano corretti e aggiornati. Tuttavia, non garantisce l'assenza di errori od omissioni né è responsabile dei danni o pregiudizi che possano derivare dall'utilizzo delle informazioni contenute nel sito web quando questi siano conseguenza di circostanze estranee al suo controllo.\nEYE STAR, S.L. non garantisce nemmeno la disponibilità e la continuità del funzionamento del sito web, potendosi verificare interruzioni per cause tecniche, di manutenzione o per circostanze estranee al suo controllo.\nIl sito web può contenere collegamenti a siti web di terzi. EYE STAR, S.L. non si assume alcuna responsabilità per i contenuti, i servizi, il funzionamento o le politiche sulla privacy di tali siti web esterni."],
      ["Protezione dei dati personali", "Il trattamento dei dati personali che possono essere raccolti attraverso questo sito web sarà effettuato in conformità alla normativa vigente in materia di protezione dei dati personali.\nLe informazioni relative al titolare del trattamento, alle finalità del trattamento, alle basi giuridiche, ai destinatari, ai periodi di conservazione e ai diritti che gli utenti possono esercitare sono disponibili nell'Informativa sulla privacy del sito web."],
      ["Cookie", "Questo sito web può utilizzare cookie e tecnologie simili.\nLe informazioni relative ai cookie utilizzati, alle loro finalità, agli eventuali terzi coinvolti e al modo in cui l'utente può gestire le proprie preferenze sono disponibili nell'Informativa sui cookie.\nI cookie non strettamente necessari saranno utilizzati in conformità alla normativa applicabile e, ove necessario, previa acquisizione del consenso dell'utente."],
      ["Comunicazioni commerciali", "Qualora l'utente abbia prestato il proprio consenso a ricevere comunicazioni commerciali per via elettronica, queste saranno effettuate in conformità alla legislazione vigente.\nL'utente potrà opporsi all'invio di comunicazioni commerciali in qualsiasi momento mediante i meccanismi predisposti a tal fine in ciascuna comunicazione."],
      ["Modifiche", "EYE STAR, S.L. si riserva il diritto di modificare, aggiornare o eliminare, in qualsiasi momento e senza necessità di preavviso, i contenuti e i servizi offerti tramite il sito web, nonché le presenti Note legali.\nLe modifiche saranno applicabili dal momento della loro pubblicazione sul sito web."],
      ["Legge applicabile e foro competente", "Il rapporto tra EYE STAR, S.L. e l'utente sarà disciplinato dalla legge spagnola.\nPer la risoluzione di qualsiasi controversia che possa sorgere in relazione all'accesso o all'utilizzo del sito web, saranno competenti i tribunali che risultino tali in conformità alla normativa applicabile.\nQualora l'utente rivesta la qualifica di consumatore, saranno rispettate le norme imperative in materia di competenza giurisdizionale e protezione dei consumatori applicabili."],
    ]},
    privacy: { title: "Informativa sulla privacy", date: "18 luglio 2025", sections: [
      ["Titolare del trattamento", "Ragione sociale: EYE STAR SL\nNIF: B87171740\nDominio: https://www.hotel-martorell.com/\nIndirizzo postale: Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nIndirizzo e-mail: administracion@hotel-martorell.com\nTelefono: +34 937 745 160"],
      ["Protezione dei dati", "In conformità alla normativa vigente e applicabile in materia di protezione dei dati personali, vi informiamo che i vostri dati saranno inseriti nel sistema di trattamento di titolarità di EYE STAR SL, con NIF B87171740 e sede legale in Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid). Di seguito vengono fornite le informazioni sui trattamenti effettuati."],
      ["Gestione delle prenotazioni online di alloggio", "Finalità: registrazione e gestione delle prenotazioni online di alloggio.\nPeriodo di conservazione: 3 anni (Ordinanza INT/1922/2003, del 3 luglio, sui registri e sulle schede di ingresso dei viaggiatori nelle strutture ricettive e analoghe).\nBase giuridica: il consenso dell'interessato.\nDati di base: nome e cognome, telefono, NIF, indirizzo e-mail, dati economici o assicurativi.\nDati sensibili: dati relativi ai minori.\nComunicazioni: se necessario, i vostri dati saranno comunicati all'Agenzia delle Entrate, a banche e casse di risparmio, alle Forze e ai Corpi di Sicurezza e alle autorità competenti, al fine di adempiere agli obblighi amministrativi e di sicurezza stabiliti dalla normativa applicabile. La base che legittima la comunicazione è l'adempimento di una legge."],
      ["Azioni commerciali (modulo web)", "Finalità: acquisizione, registrazione e trattamento dei dati per gestire le vostre richieste e/o domande, nonché per pubblicità e prospezione commerciale.\nPeriodo di conservazione: finché viene mantenuto il consenso prestato, salvo obbligo di legge.\nBase giuridica: il consenso dell'interessato.\nDati di base: nome e cognome, indirizzo e-mail."],
      ["Gestione degli utenti web", "Finalità: acquisizione, registrazione e trattamento dei dati dell'utente.\nPeriodo di conservazione: finché viene mantenuto il consenso prestato, salvo obbligo di legge.\nBase giuridica: il consenso dell'interessato.\nDati di base: nome e cognome, indirizzo e-mail."],
      ["Installazione di cookie", "Finalità: gestione e installazione dei cookie.\nPeriodo di conservazione: finché viene mantenuto il consenso prestato.\nBase giuridica: il consenso dell'interessato.\nDati di base: indirizzo e-mail, indirizzo IP."],
      ["Newsletter", "Finalità: gestione dell'iscrizione alla newsletter per effettuare i relativi invii.\nPeriodo di conservazione: finché viene mantenuto il consenso prestato.\nBase giuridica: il consenso dell'interessato.\nDati di base: nome e cognome, indirizzo e-mail."],
      ["Gestione del modulo web", "Finalità: gestire le vostre richieste e/o domande.\nPeriodo di conservazione: finché viene mantenuto il consenso prestato.\nBase giuridica: il consenso dell'interessato.\nDati di base: nome e cognome, indirizzo e-mail, indirizzo IP."],
      ["Diritti degli interessati", "Potete esercitare i diritti di accesso, rettifica, limitazione, cancellazione, portabilità e opposizione al trattamento dei vostri dati personali, nonché il diritto a non essere sottoposti a decisioni automatizzate (compresa la profilazione) e a revocare il consenso prestato:\n• Accesso: ottenere conferma dell'eventuale trattamento dei vostri dati e, in tal caso, i dati specifici e le informazioni legali sul trattamento.\n• Rettifica: far modificare i dati inesatti o incompleti.\n• Limitazione: far limitare le finalità del trattamento in determinati casi.\n• Cancellazione: far cancellare i vostri dati, salvo le eccezioni previste dal GDPR.\n• Portabilità: ricevere i vostri dati in un formato strutturato, di uso comune e leggibile da dispositivo automatico, e trasmetterli a un altro titolare.\n• Opposizione: che i vostri dati non siano trattati o che il trattamento cessi nei casi previsti.\n• A non essere sottoposti a decisioni automatizzate, compresa la profilazione.\n• Revoca del consenso: in qualsiasi momento e gratuitamente."],
      ["Esercizio dei diritti", "Per esercitare questi diritti potete presentare una richiesta scritta all'indirizzo Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), all'attenzione di EYE STAR SL, o inviare un'e-mail a administracion@hotel-martorell.com. L'interessato dovrà identificarsi in modo attendibile; in caso di dubbi sulla sua identità, potrà essergli richiesto di integrare la richiesta. La richiesta può essere presentata da un rappresentante legale o volontario debitamente identificato e autorizzato. Occorre specificare il diritto o i diritti che si intendono esercitare, indicando un indirizzo ai fini delle notifiche e allegando i documenti giustificativi necessari. Non verranno mai fornite informazioni per telefono."],
      ["Reclamo all'autorità di controllo", "Avete il diritto di presentare un reclamo all'Agenzia spagnola per la protezione dei dati qualora riteniate che un fatto possa costituire una violazione della normativa applicabile in materia di protezione dei dati."],
      ["Misure di sicurezza", "EYE STAR SL si impegna ad adottare le misure tecniche e organizzative necessarie, in base al livello di rischio dei trattamenti effettuati, in modo da garantire l'integrità, la riservatezza e la disponibilità dei dati."],
    ]},
    cookies: { title: "Informativa sui cookie", sections: [
      ["Cosa sono", "I cookie sono piccoli file memorizzati sul vostro dispositivo durante la navigazione che permettono di ricordare preferenze o misurare l'uso del sito."],
      ["Cookie che utilizziamo", "Cookie tecnici necessari al funzionamento (lingua, sessione di amministrazione e memorizzazione della tua scelta sui cookie) e, solo con il tuo consenso, cookie analitici di Google Analytics 4 (_ga, _ga_*; durata massima 13 mesi) con IP anonimizzato per capire come viene usato il sito e migliorarlo."],
      ["Terze parti", "La mappa integrata di Google Maps e il motore di prenotazione esterno possono installare i propri cookie, soggetti alle loro politiche."],
      ["Come gestirli", "Potete configurare il vostro browser per bloccare o eliminare i cookie. Questo può influire su alcune funzionalità del sito."],
      ["Gestire il tuo consenso", "Al primo accesso puoi accettare, rifiutare o configurare i cookie per categoria. Puoi cambiare la tua scelta in qualsiasi momento dal link «Impostazioni cookie» nel piè di pagina. Se rifiuti i cookie analitici, Google Analytics funziona senza cookie (Consent Mode) e riceve solo segnali anonimi."],
    ]},
    updated: "Ultimo aggiornamento",
  },
  consent: {
    eyebrow: "Cookie",
    title: "La tua privacy, a modo tuo",
    text: "Usiamo cookie propri necessari e, solo se accetti, cookie analitici (Google Analytics) per capire come viene usato il sito e migliorarlo. Puoi cambiare la tua scelta quando vuoi da «Impostazioni cookie», nel piè di pagina.",
    more: "Informativa sui cookie",
    acceptAll: "Accetta tutti",
    reject: "Rifiuta",
    configure: "Configura",
    save: "Salva selezione",
    close: "Chiudi",
    always: "Sempre attivi",
    necessary: { t: "Necessari", d: "Indispensabili per il funzionamento del sito: lingua, sicurezza e memorizzazione della tua scelta sui cookie." },
    analytics: { t: "Analitici", d: "Google Analytics con IP anonimizzato, per misurare le visite e migliorare il sito. Se li rifiuti, vengono inviati solo segnali anonimi senza cookie." },
    marketing: { t: "Marketing", d: "Per misurare le campagne e personalizzare gli annunci Google. Attualmente non utilizziamo alcun cookie di questo tipo." },
  },
  notFound: { title: "Pagina non trovata", text: "La pagina che cercate non esiste o è stata spostata.", cta: "Torna alla home" },
  chat: {
    open: "Assistente dell'hotel",
    close: "Chiudi",
    title: "Assistente dell'hotel",
    subtitle: "Risposte immediate, 24 ore su 24",
    intro: "Ciao, sono l'assistente virtuale dell'Hotel Ciutat Martorell. Chiedimi di camere, colazione, come arrivare, sale o eventi.",
    placeholder: "Scrivi la tua domanda…",
    send: "Invia",
    suggestions: ["A che ora è la colazione?", "Come arrivo da Barcellona?", "Avete il parcheggio?"],
    human: "Preferisci parlare con una persona?",
    call: "Chiama",
    whatsapp: "WhatsApp",
    book: "Prenota",
    error: "In questo momento non posso rispondere. Chiamaci al",
    disclaimer: "Assistente automatico: può commettere errori. Per prenotare, usa il pulsante Prenota.",
  },
  admin: {
    googleLogin: "Accedi con Google",
    or: "o",
    aiTranslate: "Traduci con l'IA dall'ES",
    login: "Accesso al pannello",
    email: "Email",
    password: "Password",
    enter: "Entra",
    logout: "Esci",
    panel: "Pannello contenuti",
    tabs: { nye: "Capodanno", stats: "Statistiche", ai: "Assistente IA", leads: "Richieste", content: "Testi", rooms: "Camere", meeting: "Sale", faqs: "FAQ", gallery: "Galleria", blog: "Blog", survey: "Sostenibilità", settings: "Dati dell'hotel" },
    save: "Salva",
    saved: "Salvato",
    add: "Aggiungi",
    delete: "Elimina",
    status: { nuevo: "Nuovo", en_proceso: "In corso", cerrado: "Chiuso" },
    noLeads: "Ancora nessuna richiesta.",
    resend: "Reinvia avviso",
    resendOk: "Avviso reinviato a",
    resendFail: "Impossibile inviare l'avviso",
    notifySent: "Avviso email inviato",
    notifyFailed: "Avviso email non riuscito",
    notifyUnknown: "Nessun registro di invio",
  },
  common: {
    seeMore: "Vedi altro",
    bookNow: "Prenota ora",
    call: "Chiama l'hotel",
    placeholderNote: "Fotografia provvisoria",
  },
  pages: {
    rooms: {
      seoTitle: "Camere a Martorell · Doppia e Twin da 21 m²",
      seoDesc: "Camere Doppia e Twin con Wi-Fi in fibra, scrivania e colazione a buffet. Doppia e Twin. Prenota diretto al miglior prezzo.",
      heroTitle: ["Camere pensate", "per un vero riposo"],
      heroText: "92 camere progettate per il riposo assoluto del viaggiatore d'affari e di piacere.",
    },
    roomDetailSuffix: "Camere",
    corporate: {
      seoTitle: "Hotel per aziende e sale riunioni a Martorell",
      seoDesc: "Tariffe aziendali, 3 sale riunioni fino a 180 persone e alloggio a 5 min da SEAT-CUPRA e dalle zone industriali di Martorell. Preventivo in 24 h.",
      heroTitle: ["La vostra base operativa", "nel corridoio del Llobregat"],
    },
    meetingRooms: {
      seoTitle: "Sale riunioni ed eventi a Martorell",
      seoDesc: "3 sale con luce naturale da 35 a 220 m² per riunioni, formazioni e convegni da 12 a 180 persone. Audiovisivi, fibra e coffee break.",
      heroTitle: ["Tre sale,", "infiniti allestimenti"],
    },
    events: {
      seoTitle: "Matrimoni, celebrazioni e gruppi a Martorell",
      heroTitle: ["I grandi giorni meritano", "un luogo all'altezza"],
      stepsTitle: "Tre passi, zero preoccupazioni",
    },
    restaurant: {
      seoTitle: "Ristorante a Martorell · Cucina mediterranea",
      heroTitle: ["Cucina mediterranea", "di mercato"],
    },
    location: {
      seoTitle: "Posizione · Hotel a Martorell a 30 min da Barcellona",
      heroTitle: ["Al centro di tutto", "ciò che conta"],
      distancesTitle: "Distanze e tempi",
    },
    gallery: {
      seoDesc: "Fotografie dell'Hotel Ciutat Martorell 4★ a Martorell: camere Doppia e Twin, bagni, sale riunioni, Sala Banchetti, ristorante My Bar, aree comuni e dintorni.",
      biosphereNote: "L'Hotel Ciutat Martorell possiede la certificazione Biosphere di turismo sostenibile. Scopri tutte le nostre azioni e impegni in materia di sostenibilità direttamente sul nostro profilo ufficiale.",
    },
    blog: { seoDesc: "Guide pratiche su Martorell, Barcellona e Montserrat: come arrivare in treno o in auto, cosa visitare, dove mangiare e consigli per viaggiatori d'affari e famiglie." },
    faq: { eyebrow: "Domande frequenti", home: "Quello che ci chiedono più spesso", rooms: "Sulle camere", corporate: "Su riunioni e soggiorni aziendali", events: "Su matrimoni, feste e gruppi", restaurant: "Sul ristorante" },
    biosphere: { seoTitle: "Sostenibilità · Certificazione Biosphere" },
    contact: { hoursValue: "Check-in 15:00 · Check-out 12:00" },
    seal: { sustainableTourism: "Turismo sostenibile", certifiedBy: "Certificato da", viewCert: "Vedi la certificazione" },
    bookingCta: {
      eyebrow: "Prenotazione diretta",
      rooms: { title: "Prenota al miglior prezzo garantito", text: "Prenotando direttamente sul sito ufficiale ottieni la tariffa migliore, senza intermediari né commissioni." },
      location: { title: "A 30 minuti da Barcellona e Montserrat", text: "Soggiorna accanto alle stazioni Renfe e FGC, con l'aeroporto a 30 minuti. Prenota diretto al miglior prezzo garantito." },
    },
    blogPost: {
      sidebarTitle: "Dormi a 100 m dal treno",
      cta: {
        eyebrow: "Prenotazione diretta",
        secondary: "Richiedi un preventivo",
        transport: { title: "Dormi a 100 m dal treno", text: "Soggiorna accanto alle stazioni Renfe e FGC e raggiungi Barcellona in 30 minuti. Miglior prezzo garantito sul sito ufficiale." },
        guides: { title: "La tua base per scoprire Martorell", text: "Barcellona, Montserrat e l'aeroporto a 30 minuti. Prenota diretto e inizia a pianificare la tua fuga." },
        business: { title: "Alloggio e sale per la tua azienda", text: "A 5 minuti dalla zona industriale, con sale riunioni e tariffa aziendale. Chiedici un preventivo su misura." },
        default: { title: "Prenota il tuo soggiorno a Martorell", text: "Hotel 4★ a 30 minuti da Barcellona. Miglior prezzo garantito prenotando direttamente." },
      },
    },
    homeHeadings: {
      presentation: ["Hotel 4 stelle a Martorell.", "Riposo, lavoro e celebrazioni", "a 30 minuti da Barcellona."],
      gastronomy: ["Cucina mediterranea", "di mercato, senza fretta"],
      extras: ["Un evento, una riunione", "o un lungo soggiorno?"],
      heroRooms: "Camere",
    },
  },
};

export default it;
